import { render, staticRenderFns } from "./VAdministrationProjectForm.vue?vue&type=template&id=6c3479a4&"
import script from "./VAdministrationProjectForm.vue?vue&type=script&lang=ts&"
export * from "./VAdministrationProjectForm.vue?vue&type=script&lang=ts&"
import style0 from "./VAdministrationProjectForm.vue?vue&type=style&index=0&id=6c3479a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports